import { useNavigate } from "react-router";
import { useAccountData } from "./useAccountData";
import { useCallback } from "react";

/**
 * Handles Cta click. It can be a link inside the app or an external link. It also supports
 * navigating to a new channel or stream by the stream id.
 */
export function useHandleCTAClick(link: string) {
  const navigate = useNavigate();
  const accountData = useAccountData();

  const handleCTAClick = useCallback(() => {
    if (link.startsWith("/channel")) {
      navigate(link);
    } else if (link.includes("/stream")) {
      const channels = accountData?.home_tab_channels;
      const streams = channels?.flatMap((channel) => channel.streams);
      const urlChunks = link?.split("/") ?? [];
      const urlStreamId = urlChunks[urlChunks.length - 1];
      const newActiveChannel = streams?.find((stream) => {
        return urlStreamId === stream.id;
      });

      navigate(`/channel/${newActiveChannel?.slug}`);
    } else if (link.includes("news/details")) {
      navigate(new URL(link).pathname);
    } else {
      const linkUrl = new URL(link || link);
      window.location.href = linkUrl.pathname + linkUrl.search;
    }
  }, [link]);

  return handleCTAClick;
}
